'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUser = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUser = exports.getUser = (0, _getIn2.default)(['auth', 'user']);


//////////////////
// WEBPACK FOOTER
// ./js/selectors/userSelectors/getUser.js
// module id = 624
// module chunks = 2 3